import { useState, useEffect } from "react";
import { useAuth } from "@contexts/AuthContext";

export function ApiSettings() {
  const { currentUser, regenerateApiKey, copyApiKey } = useAuth();
  const [apiKey, setApiKey] = useState("••••••••••••••••");
  const [showKey, setShowKey] = useState(false);

  useEffect(() => {
    if (currentUser?.api_key) {
      setApiKey(currentUser.api_key);
    }
  }, [currentUser]);

  const handleRegenerate = async () => {
    await regenerateApiKey();
  };

  const handleCopy = () => {
    copyApiKey();
  };

  return (
    <div className="api-settings">
      <div className="settings-section">
        <h4>API Access</h4>
        <p
          className="text-tertiary"
          style={{ fontSize: "0.85rem", marginBottom: "1.5rem" }}
        >
          Use your API key to access AnchorMarks from other applications or
          scripts. Keep this key secret!
        </p>

        <div className="form-group">
          <label>Your API Key</label>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <input
              type={showKey ? "text" : "password"}
              className="form-input"
              value={apiKey}
              readOnly
              style={{ flex: 1, fontFamily: "monospace" }}
            />
            <button
              className="btn btn-outline"
              onClick={() => setShowKey(!showKey)}
            >
              {showKey ? "Hide" : "Show"}
            </button>
            <button className="btn btn-outline" onClick={handleCopy}>
              Copy
            </button>
          </div>
        </div>

        <div style={{ marginTop: "2rem" }}>
          <button className="btn btn-outline-danger" onClick={handleRegenerate}>
            Regenerate API Key
          </button>
          <p
            className="text-tertiary"
            style={{ fontSize: "0.75rem", marginTop: "0.5rem" }}
          >
            Warning: The old key will stop working immediately.
          </p>
        </div>
      </div>
    </div>
  );
}
